var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.555,
    height: 63.684,
    viewBox: "0 0 56.555 63.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0.51 0.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,5.822c3.384,2.213,4.363,3.866,10.669,6.769s12.608.27,17.82-.819C34.6,10.5,36.364,6.638,30.337,8.345s-11.219.359-13.13-.706-5.545-2.757.539-1.681S25.4,4.551,22.027,4.051,16.383,1.076,10.074.1C5.028-.69,1.156,3.568,0,5.822Z",
    transform: "translate(2.177 35.338)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.1,36.964l-2.968,3.28c-.5-.829-1-2.485-1.113-5.8C-.089,31.227.23,15.982.271,8.761A1.033,1.033,0,0,1,.89,7.814C1.509,7.578,26.352-.179,26.73,0c.735.354,21.016,5.8,25.963,7.811.493.2.743.593.743,2.012.008.593-.153,7.855-.145,8.522-.123,3.1-.2,20.707-.48,21.185-1.182,2.012-1.443,5.688-11.86,13.492C34,58.231,28.505,60.364,26.859,60.836c-8.677-3.555-15.723-8.858-20.3-12.311l7.792,2.428c11.128,5.837,10.133,5.265,12.358,6.094,14.216-6.037,20.3-14.672,22.153-17.514.456-.7.7-13.995.858-16.926L49.6,10.535C42.228,8.443,27.325,4.357,26.733,4.262S11.4,8.364,4.108,10.535l0,0Z",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 0, 1.865)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.446,9.171a2.709,2.709,0,0,0,.781-.105,1.48,1.48,0,0,0,.608-.357,1.717,1.717,0,0,0,.391-.715,3.562,3.562,0,0,0,.151-1.135,3.209,3.209,0,0,0-.151-1.072,1.4,1.4,0,0,0-.391-.672,1.3,1.3,0,0,0-.608-.336,2.709,2.709,0,0,0-.781-.105H4.582v4.5H7.446Z",
    transform: "translate(16.668 19.43)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M93.732,12.549a1.491,1.491,0,0,0,.955-.252,1.123,1.123,0,0,0,.3-.9,2.023,2.023,0,0,0-.2-.967,1.058,1.058,0,0,0-.608-.525,2.983,2.983,0,0,0-1.107-.169,2.344,2.344,0,0,0-1.173.252,1.364,1.364,0,0,0-.63.841,5.925,5.925,0,0,0-.2,1.723h2.649Z",
    transform: "translate(-49.038 17.921)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M128.06,16.389a5.712,5.712,0,0,0,.89-.42V10.294c-.289-.1-.593-.2-.911-.295a3.459,3.459,0,0,0-1.02-.147,2.708,2.708,0,0,0-1.3.274,1.629,1.629,0,0,0-.694,1.03,8.008,8.008,0,0,0-.217,2.143,8.323,8.323,0,0,0,.2,2.038,1.642,1.642,0,0,0,.673.987,2.352,2.352,0,0,0,1.215.274h0A3.1,3.1,0,0,0,128.06,16.389Z",
    transform: "translate(-74.908 17.885)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(20.635 25.963)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(9.325 25.963)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(20.635 18.409)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-9",
    "data-name": "Vector",
    d: "M6.424,0V6.4H0V0Z",
    transform: "translate(9.325 18.409)",
    fill: "#0086e6",
    stroke: "#0086e6",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLogo);
export default __webpack_public_path__ + "static/media/RiskLogo.378f5ff58a59273f34db0accf30c72b5.svg";
export { ForwardRef as ReactComponent };